<template>
  <div>
      <navbar/>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4 ">
                    <h3>Nuevo Archivo</h3>
                    <input type="file" ref="files" class="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1">
                    <button @click="cargar">Cargar</button>
                </div>
                <div class="col-md-8 ">
                    <h3>Archivos</h3>
                    <table class="table ">
                        <thead>
                            <tr>
                                <th scope="col">Nombre</th>
                                <th scope="col">Etiqueta</th>
                                <th scope="col"></th>
                              
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in allArchivo" :key="item.id">
                                <td>{{item.nombre}}</td>
                                <td>{{item.tag}}</td>
                                <td><button @click="bajar(item)">bajar</button> <button @click="borrar(item)">borrar</button> </td>
                            </tr>
                        </tbody>
                        </table>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
export default {
    components:{
        navbar: () => import('@/views/Agente/navBar.vue')
    },
    data() {
        return {
            form: {
                companyname: this.$store.state.auth.company,
                idobjeto: this.$route.params.id,
                tipoobjeto: this.$route.params.tipo,
                tags: '',
                file: null,
                filesize: 0
            },
        }
    },
    computed:{
        ...mapGetters('validatetoken', {
            allArchivo: 'allArchivo'
        }),
        archivos(){
            return{
                idobjeto: this.$route.params.id,
                tipoobjeto: this.$route.params.tipo
            }
        }
    },
    methods:{
          ...mapActions('validatetoken', { 
            getAllArchivos: 'getAllArchivos',
            addArchivo: 'addArchivo',
            download: 'download',
            destroyFile: 'destroyFile'
        }),
        getAll(){
            Promise.all([
                this.getAllArchivos(this.archivos)
            ])
        },
        cargar(){
          
            this.form.file = this.$refs.files.files[0]
            this.form.tags = this.$refs.files.files[0].name
            this.form.filesize = this.$refs.files.files[0].size
            this.addArchivo({ endpoint: 'uploadfile', dataToSend: this.form })
            .then(()=>{
                this.getAll()
            })
        },
        bajar(item){
            this.download({ endpoint: 'downloadfile', dataToSend: { id: item.id, companyname: this.form.companyname }, name: item.nombre })
        },
        borrar(item){
            // console.log(item)
            this.destroyFile({ id: item.id })
            .then(()=>{
                this.getAll()
            })
        }

    },
    created(){
        this.getAll()
    }
}
</script>

<style>

</style>